module.exports = __webpack_public_path__ + "static/media/excel.c425b0e9.svg";